import { render, staticRenderFns } from "./TributeStepper.vue?vue&type=template&id=019a1d35&scoped=true"
import script from "./TributeStepper.vue?vue&type=script&lang=js"
export * from "./TributeStepper.vue?vue&type=script&lang=js"
import style0 from "./TributeStepper.vue?vue&type=style&index=0&id=019a1d35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a1d35",
  null
  
)

export default component.exports